import { render, staticRenderFns } from "./SalutationChoiceModal.vue?vue&type=template&id=7d5d0bf4&scoped=true"
import script from "./SalutationChoiceModal.vue?vue&type=script&lang=js"
export * from "./SalutationChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./SalutationChoiceModal.vue?vue&type=style&index=0&id=7d5d0bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d0bf4",
  null
  
)

export default component.exports